import React, {Component} from 'react';

export const ExemploCtx = React.createContext()

export default class ExemploContext extends Component {

    
    render(){
        let ctx = {
            
        };

        return (
            <ExemploCtx.Provider value={ctx}>
                {this.props.children}
            </ExemploCtx.Provider>
        )
    }   
}